(() => {
  const current = document.currentScript || document.querySelector('script[src*="dayvee-site-consistency.js"]');
  if (!current || !current.src) return;
  const base = current.src.split('?')[0].replace(/dayvee-site-consistency\.js$/, '');
  const version = '20261103-consent-vor-quiz';

  if (!document.getElementById('dayvee-mega-image-fit')) {
    const style = document.createElement('style');
    style.id = 'dayvee-mega-image-fit';
    style.textContent = '[data-dayvee-mega-menu] .dmm-product-image{transform:none!important;object-fit:contain!important;object-position:center center!important;}';
    document.head.appendChild(style);
  }

  const renameMegaHeadings = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-dayvee-mega-menu] .dmm-products-title').forEach((heading) => {
      if ((heading.textContent || '').trim().toLowerCase() === 'beliebte produkte') {
        heading.textContent = 'Passende Produkte';
      }
    });
  };

  const normalizeWeightLabels = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.dayvee-goal-products__tab[data-dgp-goal-key="gewicht"]').forEach((tab) => {
      tab.textContent = 'Gewicht';
    });
    scope.querySelectorAll('.dayvee-goal-products__panel[data-dgp-goal-key="gewicht"] .dayvee-goal-products__goal-title').forEach((title) => {
      title.textContent = 'Gewicht';
    });
  };

  const addQuizResultNotice = () => {
    const root = document.querySelector('.dqr');
    if (!root || root.querySelector('[data-dayvee-result-nem-notice]')) return;

    if (!document.getElementById('dayvee-result-nem-notice-style')) {
      const style = document.createElement('style');
      style.id = 'dayvee-result-nem-notice-style';
      style.textContent = `
        .dqr .dqr__nem-notice { background: var(--dqr-final-bg, #f5f0e8); padding: 0 0 var(--dqr-pad, 68px); }
        .dqr .dqr__nem-notice-card { border: 1px solid var(--dqr-border, #dce5ed); border-left: 4px solid var(--dqr-accent, #c9823b); border-radius: 14px; background: var(--dqr-card-bg, #ffffff); padding: 20px 22px; color: var(--dqr-muted, #5f6b7a); font-size: 13.5px; line-height: 1.6; }
        .dqr .dqr__nem-notice-title { margin: 0 0 10px; color: var(--dqr-text, #102033); font-family: var(--font-heading-family); font-size: 20px; line-height: 1.3; font-weight: 600; }
        .dqr .dqr__nem-notice-card p { margin: 0; color: inherit; }
        .dqr .dqr__nem-notice-card p + p { margin-top: 6px; }
      `;
      document.head.appendChild(style);
    }

    const section = document.createElement('div');
    section.className = 'dqr__nem-notice';
    section.setAttribute('data-dayvee-result-nem-notice', '');
    const inner = document.createElement('div');
    inner.className = 'dqr__inner';
    const card = document.createElement('aside');
    card.className = 'dqr__nem-notice-card';
    card.setAttribute('aria-label', 'Wichtige Hinweise zu Nahrungsergänzungsmitteln');
    const title = document.createElement('h2');
    title.className = 'dqr__nem-notice-title';
    title.textContent = 'Wichtige Hinweise';
    card.appendChild(title);
    [
      'Die angegebene empfohlene tägliche Verzehrsmenge darf nicht überschritten werden.',
      'Nahrungsergänzungsmittel sollten nicht als Ersatz für eine ausgewogene und abwechslungsreiche Ernährung verwendet werden.',
      'Außerhalb der Reichweite von Kindern aufbewahren.'
    ].forEach((text) => {
      const paragraph = document.createElement('p');
      paragraph.textContent = text;
      card.appendChild(paragraph);
    });
    inner.appendChild(card);
    section.appendChild(inner);
    root.appendChild(section);
  };

  const normalizeManufacturerContent = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-dayvee-detail-item="hersteller"]').forEach((item) => {
      const walker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if ((node.nodeValue || '').trim() === 'Herstellerangaben') {
          node.nodeValue = node.nodeValue.replace('Herstellerangaben', 'Hersteller / verantwortlicher Lebensmittelunternehmer');
        }
      }
    });
    scope.querySelectorAll('[data-dayvee-detail-panel="hersteller"]').forEach((panel) => {
      const boxes = panel.querySelectorAll('.metafield-rich_text_field');
      const targets = boxes.length ? Array.from(boxes) : [panel];
      targets.forEach((target) => {
        let first = target.firstElementChild;
        while (first) {
          const label = (first.textContent || '').replace(/\s+/g, ' ').trim().replace(/:$/, '').toLowerCase();
          const generic = label === 'hersteller' || label === 'hersteller / verantwortlicher lebensmittelunternehmer' || label === 'verantwortlicher lebensmittelunternehmer';
          if (!generic) break;
          const next = first.nextElementSibling;
          first.remove();
          first = next;
        }
      });
    });
  };

  const normalizeFooterShippingLabel = (scope = document) => {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[id^="dayvee-premium-footer-"] .dpf-col--service .dpf-link span').forEach((label) => {
      if ((label.textContent || '').trim() === 'Versandinformationen') {
        label.textContent = 'Versand- und Zahlungsinformationen';
      }
    });
  };

  const applyPageConsistency = (scope = document) => {
    renameMegaHeadings(scope);
    normalizeWeightLabels(scope);
    normalizeManufacturerContent(scope);
    normalizeFooterShippingLabel(scope);
    addQuizResultNotice();
    setTimeout(() => {
      renameMegaHeadings(document);
      normalizeWeightLabels(document);
      normalizeManufacturerContent(document);
      normalizeFooterShippingLabel(document);
      addQuizResultNotice();
    }, 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyPageConsistency(document), { once: true });
  } else {
    applyPageConsistency(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    applyPageConsistency(event.target instanceof Element ? event.target : document);
  });

  [
    'dayvee-site-consistency-core.js',
    'dayvee-mega-nav-v2.js',
    'dayvee-base-prices.js',
    'dayvee-result-products.js',
    'dayvee-ziel-variant-options.js'
  ].forEach((name) => {
    const script = document.createElement('script');
    script.src = `${base}${name}?dv=${version}`;
    script.async = false;
    document.head.appendChild(script);
  });
})();
